import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthPageComponent } from './auth-page/auth-page.component';
import { AuthValidGuard } from './guards/auth-valid.guard';
import { AuthInterceptorService } from './auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LayoutModule } from '../layouts/layout.module';
import { AuthFrameComponent } from './auth-frame/auth-frame.component';
import { AuthRoutingModule } from './auth-routing.module';
import { authReducer } from './store/auth.actions';
import { initialAuthState } from './store/auth.state';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './store/auth.effects';
import { AuthInvalidGuard } from './guards/auth-invalid.guard';
import { HybridAuthValidGuard } from './guards/hybrid-auth-valid.guard';
import { InternalUserGuard } from './guards/internal-user.guard';

@NgModule({
    declarations: [AuthPageComponent, AuthFrameComponent],
    exports: [AuthFrameComponent],
    imports: [
        CommonModule,
        AuthRoutingModule,
        LayoutModule,
        StoreModule.forFeature('auth', authReducer, {
            initialState: initialAuthState
        }),
        EffectsModule.forFeature([AuthEffects])
    ],
    providers: [
        AuthValidGuard,
        AuthInvalidGuard,
        HybridAuthValidGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        InternalUserGuard
    ]
})
export class AuthModule {}
